export default __webpack_public_path__ + "static/asfalt-dark-12fc1a7a26724fd592f628c8698bc6d0.png";